import {
  constants,
  remoteResourceInitialState,
  remoteResourceLoadFailure,
  remoteResourceLoading,
  remoteResourceLoadSuccess,
} from '../../helpers';
import { Actions, ActionType, State } from './types';
import { ClosureEvolutionRow, DashboardTotalsByCountry } from '../../types';

const lastMonth = new Date();
lastMonth.setDate(0);
const lastDay = new Date();
lastDay.setDate(lastDay.getDate() - 1);

const emptyTotalsByCountry: DashboardTotalsByCountry[] = [];

const initialState: State = {
  conciliations: {
    singleCountry: false,
    activeCountry: null,
    statuses: {
      multiCountry: remoteResourceInitialState([]),
      yesterday: remoteResourceInitialState([]),
      currentMonth: remoteResourceInitialState([]),
      lastMonth: remoteResourceInitialState([]),
    },

    totals: {
      yesterday: remoteResourceInitialState<DashboardTotalsByCountry[]>(emptyTotalsByCountry),
      currentMonth: remoteResourceInitialState<DashboardTotalsByCountry[]>(emptyTotalsByCountry),
      lastMonth: remoteResourceInitialState<DashboardTotalsByCountry[]>(emptyTotalsByCountry),
    },
  },

  autoUpdate: {
    time: new Date().getTime() + constants.defaultDashboardTimer * 60000,
    lastUpdate: new Date(),
  },
  masterStatus2: remoteResourceInitialState([]),
  fiscalStatus: {
    sovosImportStatuses: remoteResourceInitialState([]),
  },
  closureEvolution: remoteResourceInitialState<ClosureEvolutionRow[]>([]),
  closureEvolutionFilters: {
    startDate: new Date(new Date().getFullYear(), 0, 1),
    endDate: new Date(),
  },
};

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionType.changeAutoUpdate:
      return {
        ...state,
        autoUpdate: {
          time: action.autoUpdate.time,
          lastUpdate: action.autoUpdate.lastUpdate,
        },
      };
    case ActionType.findSovosImportStatusesRequested:
      return {
        ...state,
        fiscalStatus: {
          ...state.fiscalStatus,
          sovosImportStatuses: remoteResourceLoading([]),
        },
      };
    case ActionType.findSovosImportStatusesSuccess:
      return {
        ...state,
        fiscalStatus: {
          ...state.fiscalStatus,
          sovosImportStatuses: remoteResourceLoadSuccess(action.sovosImportStatuses),
        },
      };
    case ActionType.findSovosImportStatusesFailure:
      return {
        ...state,
        fiscalStatus: {
          ...state.fiscalStatus,
          sovosImportStatuses: remoteResourceLoadFailure([], action.error),
        },
      };
    case ActionType.findMastersStatus2Requested:
      return {
        ...state,
        masterStatus2: remoteResourceLoading([]),
      };
    case ActionType.findMastersStatus2Success:
      return {
        ...state,
        masterStatus2: remoteResourceLoadSuccess(action.mastersStatus),
      };
    case ActionType.findMastersStatus2Failure:
      return {
        ...state,
        masterStatus2: remoteResourceLoadFailure([], action.error),
      };
    case ActionType.findDashboardConciliationsStateRequested:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            multiCountry: remoteResourceLoading([]),
            yesterday: remoteResourceLoading([]),
            currentMonth: remoteResourceLoading([]),
            lastMonth: remoteResourceLoading([]),
          },
        },
      };
    case ActionType.findDashboardConciliationsStateSuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            ...state.conciliations.statuses,
            multiCountry: remoteResourceLoadSuccess(action.conciliationsState),
          },
        },
      };
    case ActionType.findDashboardConciliationsStateFailure:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            ...state.conciliations.statuses,
            multiCountry: remoteResourceLoadFailure([], action.error),
          },
        },
      };
    case ActionType.changeDashboardCountrySelected:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          activeCountry: action.countryCode,
          statuses: {
            ...state.conciliations.statuses,
            yesterday: remoteResourceLoading([]),
            currentMonth: remoteResourceLoading([]),
            lastMonth: remoteResourceLoading([]),
          },
        },
      };
    case ActionType.setSingleCountryDashboard:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          singleCountry: true,
          activeCountry: action.countryCode,
        },
      };
    case ActionType.getDashboardConciliationsStateYesterdaySuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            ...state.conciliations.statuses,
            yesterday: remoteResourceLoadSuccess(action.conciliationsStatusYesterday),
          },
        },
      };
    case ActionType.getDashboardConciliationsStateCurrentMonthSuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            ...state.conciliations.statuses,
            currentMonth: remoteResourceLoadSuccess(action.conciliationsStatusCurrentMonth),
          },
        },
      };
    case ActionType.getDashboardConciliationsStateLastMonthSuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          statuses: {
            ...state.conciliations.statuses,
            lastMonth: remoteResourceLoadSuccess(action.conciliationsStatusLastMonth),
          },
        },
      };
    // =================================================================
    // Totals Cards (FLEX vs SOVOS)  <-- NUEVO
    // =================================================================
    case ActionType.getDashboardTotalsYesterdaySuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          totals: {
            ...state.conciliations.totals,
            yesterday: remoteResourceLoadSuccess(action.totalsYesterday),
          },
        },
      };

    case ActionType.getDashboardTotalsCurrentMonthSuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          totals: {
            ...state.conciliations.totals,
            currentMonth: remoteResourceLoadSuccess(action.totalsCurrentMonth),
          },
        },
      };

    case ActionType.getDashboardTotalsLastMonthSuccess:
      return {
        ...state,
        conciliations: {
          ...state.conciliations,
          totals: {
            ...state.conciliations.totals,
            lastMonth: remoteResourceLoadSuccess(action.totalsLastMonth),
          },
        },
      };

    case ActionType.findDashboardClosureEvolutionRequested:
      return {
        ...state,
        closureEvolution: remoteResourceLoading([]),
      };

    case ActionType.getDashboardClosureEvolutionSuccess:
      return {
        ...state,
        closureEvolution: remoteResourceLoadSuccess(action.closureEvolution),
      };

    case ActionType.getDashboardClosureEvolutionFailure:
      return {
        ...state,
        closureEvolution: remoteResourceLoadFailure([], action.error),
      };

    case ActionType.changeDashboardClosureEvolutionFilterStartAccountingDate:
      return {
        ...state,
        closureEvolutionFilters: {
          ...state.closureEvolutionFilters,
          startDate: action.startDate,
        },
      };

    case ActionType.changeDashboardClosureEvolutionFilterEndAccountingDate:
      return {
        ...state,
        closureEvolutionFilters: {
          ...state.closureEvolutionFilters,
          endDate: action.endDate,
        },
      };

    default:
      return state;
  }
};

export default reducer;
